"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Badge = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Box_1 = require("../Box");
exports.Badge = react_1.forwardRef((props, ref) => {
    return (jsx_runtime_1.jsx(Box_1.Box, Object.assign({ ref: ref, noWrap: true, fontSize: "sm", borderRadius: "1rem", display: "inline-block", verticalAlign: "middle", textAlign: "center", fontWeight: "bold", py: 0, px: 2, _empty: { display: 'none' } }, props), void 0));
});
//# sourceMappingURL=index.js.map